export const URL_EMPTY = '/'
export const URL_HOME = '/sam/dashboard'
export const URL_LOGIN = '/sam/login/'
export const URL_SIGNUP = '/sam/signup/'

export const URL_DASHBOARD = '/sam/dashboard/'
export const URL_APPLY_REVART = '/sam/apply_for_revart/'
export const URL_BULK_UPLOAD = '/sam/pieces/bulk-upload/'
export const URL_BULK_UPLOAD_UPDATE = '/sam/pieces/bulk-upload-update/'
export const URL_IMPORT_CSV = '/sam/pieces/import-csv/'

export const URL_PIECES = '/sam/pieces/'
export const URL_NEW_PIECES = '/sam/pieces/new/'
export const URL_NEW_PIECES_STEPPER = '/sam/pieces/stepper/new/'
export const URL_EDIT_PIECES_ID = '/sam/pieces/edit/:id/'

export const URL_COLLECTIONS = '/sam/collections/'
export const URL_NEW_COLLECTIONS = '/sam/collections/new/'
export const URL_EDIT_COLLECTIONS_ID = '/sam/collections/edit/:id/'

export const URL_EXHIBITIONS = '/sam/exhibitions/'
export const URL_NEW_EXHIBITIONS = '/sam/exhibitions/new'
export const URL_EDIT_EXHIBITIONS_ID = '/sam/exhibitions/edit/:id/'
export const URL_EXHIBITIONS_ADMIN = '/sam/admin/exhibitions/'
export const URL_ADMIN_NEW_EXHIBITIONS = '/sam/admin/exhibitions/new/'
export const URL_ADMIN_EDIT_EXHIBITIONS_ID = '/sam/admin/exhibitions/edit/:id/'
export const URL_ADMIN_EDIT_USER_ID = '/sam/admin/users/edit/:id/'

export const URL_SHOWCASE_BIO = '/sam/showcase/bio/'
export const URL_SHOWCASE_SPOTLIGHTS = '/sam/showcase/media/'
export const URL_SHOWCASE_ARTWORK = '/sam/showcase/art/'
export const URL_SHOWCASE_PUBLISH = '/sam/showcase/publish/'

export const URL_SHOWCASE_HOME = '/sam/showcase/preview/home/'
export const URL_SHOWCASE_WORK = '/sam/showcase/preview/art/'
export const URL_SHOWCASE_WORK_ID = '/sam/showcase/preview/art/:id/'
export const URL_SHOWCASE_NEWS = '/sam/showcase/preview/news/'
export const URL_SHOWCASE_ABOUT = '/sam/showcase/preview/about/'
export const URL_SHOWCASE_CONTACT = '/sam/showcase/preview/contact/'

export const URL_INCOME_ORDER = '/sam/income/order/'
export const URL_NEW_ORDERS = '/sam/income/order/new/'
export const URL_EDIT_ORDERS = '/sam/income/order/edit/:id/'
export const URL_ORDER_DETAILS = '/sam/income/order/:id/'
export const URL_INCOME_PAYMENT = '/sam/income/payment/'
export const URL_NEW_PAYMENT = '/sam/income/payment/new/'
export const URL_INCOME_REPORT = '/sam/income/report/'

export const URL_SUBSCRIPTION = '/sam/subscription/'
export const URL_SUBSCRIPTION_SUCCESS = '/sam/subscription/success/'
export const URL_SUBSCRIPTION_CANCEL = '/sam/subscription/cancel/'
export const URL_SUBSCRIPTION_FAILED = '/sam/subscription/failed/'

export const URL_AGREEMENTS = '/sam/agreements/'
export const URL_TEMPLATES = '/sam/templates/'
export const URL_STATEMENTS = '/sam/statements/'
export const URL_TEMPLATES_ID = '/sam/templates/:id/'
export const URL_STATEMENTS_ID = '/sam/statements/:id/'
export const URL_NEW_AGREEMENTS = '/sam/agreements/new/'
export const URL_SIGN_AGREEMENTS = '/sam/agreement/sign/:id/'
export const URL_EDIT_AGREEMENTS_ID = '/sam/agreements/:embed_url/:id/'

export const URL_TAXES = '/sam/taxes/'
export const URL_TEST = '/sam/Test/'

export const URL_CONTACTS = '/sam/contacts/'
export const URL_NEW_CONTACT = '/sam/contacts/new/'
export const URL_EDIT_CONTACT = '/sam/contacts/edit/:id/'
export const URL_NEW_CONTACT_PEOPLE = '/sam/contacts/people/new/'
export const URL_NEW_CONTACT_GROUP = '/sam/contacts/group/new/'
export const URL_EDIT_CONTACT_GROUP = '/sam/contacts/group/edit/:id/'

export const URL_WRITER_STATEMENT = '/sam/writer/statement/'
export const URL_WRITER_ARTWORK = '/sam/writer/artwork/'


export const URL_FAQS = '/sam/faqs/'
export const URL_FAQS_ID = '/sam/faqs/:id/'

export const URL_ACCOUNT_INFO = '/sam/account/'
export const URL_PROFILE_INFO = '/sam/profile/'

export const URL_ART_INFO = '/sam/profile/'

export const URL_CANCEL_ACCOUNT = '/sam/cancel'
export const URL_NOTIFICATION_ADMIN = '/sam/admin/notification'
export const URL_NEW_NOTIFICATION_ADMIN = '/sam/admin/notification/new/'
export const URL_USERS_ADMIN = '/sam/admin/users'

export const URL_BILLING = '/sam/billing/'
//export const URL_BILLING_ADD_METHOD = '/sam/billing/new'
